export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
export const localeOptions = [
  { id: 'en', name: 'English', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'pr', name: 'Portugués', direction: 'ltr' },
  { id: 'pl', name: 'Polaco', direction: 'ltr' },
  // { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const currentUser = {
  id:
    localStorage.getItem('gogo_current_user') !== null &&
    localStorage.getItem('gogo_current_user') !== ''
      ? JSON.parse(localStorage.getItem('gogo_current_user')).id
      : 1,
  title:
    localStorage.getItem('gogo_current_user') !== null &&
    localStorage.getItem('gogo_current_user') !== ''
      ? JSON.parse(localStorage.getItem('gogo_current_user')).title
      : 'Persona',
  img:
    localStorage.getItem('gogo_current_user') !== null &&
    localStorage.getItem('gogo_current_user') !== ''
      ? JSON.parse(localStorage.getItem('gogo_current_user')).img
      : '/assets/img/profiles/l-2.jpg',
  date:
    localStorage.getItem('gogo_current_user') !== null &&
    localStorage.getItem('gogo_current_user') !== ''
      ? JSON.parse(localStorage.getItem('gogo_current_user')).date
      : 'Last seen today 15:24',
  role:
    localStorage.getItem('gogo_current_user') !== null &&
    localStorage.getItem('gogo_current_user') !== ''
      ? JSON.parse(localStorage.getItem('gogo_current_user')).role
      : UserRole.Admin,
};

export const adminRoot = '/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/pages/miscellaneous/search`;
export const servicePath = 'https://api.coloredstrategies.com';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.bluenavy';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];
export const menuUsuario = [];
